{{#if progress}}
  <div class="progress">
    {{!-- Note: Set a min-width on .progress-bar, so the pagesCompleted/totalPages numbers remain legible --}}
    <div class="progress-bar" role="progressbar" style="width:{{moduleProgressPercentage}}%;" aria-valuenow="{{completedModules}}" aria-valuemin="0" aria-valuemax="{{totalModules}}">
      <div class="modules-completed">{{moduleProgress}}</div>
    </div>
  </div>
{{/if}}
<div class="modules"></div>
